import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compileProgram, submitProgram } from "../../actions/compile";

const Submit = ({
  match,
  compileProgram,
  compile,
  submitProgram,
  auth: { user },
}) => {
  const [code, setCode] = useState("");
  const [language, setLanguage] = useState("");
  const [input, setInput] = useState("");

  const onSubmit = (e) => {
    e.preventDefault();
    submitProgram(code, language, match.params.id, user.userName);
  };
  return (
    <div className='d-flex align-items-center flex-column'>
      <form onSubmit={(e) => onSubmit(e)}>
        <select
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
          className='form-select mb-5 p-3'
          aria-label='Default select example'
        >
          <option value='' disabled selected hidden>
            Select Your Language
          </option>
          <option value='C++'>C++</option>
          <option value='C'>C</option>
          <option value='Java'>Java</option>
          <option value='Python'>Python</option>
          <option value='JavaScript'>JavaScript</option>
        </select>
        <br />
        <textarea
          name='submit'
          cols='30'
          rows='20'
          placeholder='Paste Your Code'
          value={code}
          onChange={(e) => setCode(e.target.value)}
          required
        ></textarea>
        <br />
        <br />
        <textarea
          name='input'
          cols='10'
          rows='5'
          placeholder='Your Custom Input (Required For Run Code)'
          value={input}
          onChange={(e) => setInput(e.target.value)}
        ></textarea>
        <br />
        <button
          className='btn btn-danger px-2 my-4'
          onClick={() => compileProgram(code, language, input)}
          type='button'
        >
          Run Code
        </button>
        <button className='btn btn-success px-2 my-4 mx-2' type='submit'>
          Submit
        </button>
      </form>
      {/* {compile.result == null && (
          <img
            src={require("../../images/pc_loader.gif")}
            alt='Loading . . . '
            className='load'
          />
      )} */}

      {compile.result && <p>Output:- </p>}

      {compile.result === "Success" && (
        <>
          <textarea
            rows='1'
            className='mb-3 text-center'
            style={{ backgroundColor: "green", color: "white" }}
          >
            {compile.result}
          </textarea>
        </>
      )}
      {compile.result === "Failed" && (
        <>
          <textarea
            rows='1'
            className='mb-3 text-center'
            style={{ backgroundColor: "red", color: "white" }}
          >
            {compile.result}
          </textarea>
        </>
      )}
      {compile.result !== "Success" &&
        compile.result !== "Failed" &&
        compile.result && (
          <>
            <textarea className='mb-3 text-center'>{compile.result}</textarea>
          </>
        )}
    </div>
  );
};

Submit.propTypes = {
  compileProgram: PropTypes.func.isRequired,
  submitProgram: PropTypes.func.isRequired,
  compile: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  compile: state.compile,
  auth: state.auth,
});

export default connect(mapStateToProps, { compileProgram, submitProgram })(
  Submit
);
